/* eslint-disable */
import React, { Component } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { Filter, DollarSign, X, Gift, ShoppingCart, Package, Info, TriangleAlert, Store, Users, PartyPopper, Settings, Save, LucideTag, Lightbulb, TrendingUp } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showAlert, showLoader, hideLoader } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Datepickerfun from "./Datepickerfun";
import SpendingAnalysis from "./SpendingAnalysis";
import PopularItems from "./PopularItems";
import CustomerAnalysis from "./CustomerAnalysis";
import { error } from "jquery";

var moduleName = "Customer Analytics";

class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || "",
      mainTab: "analytics",
      merchantType: "bundleoffer",
      clearDates: "No",
      filterIsActive: "No",
      clearOulet: "No",
      clearTrans: "No",
      activeTab: "spending",
      fromDate: "",
      toDate: "",
      overalldata: {},
      spendingOutletData: [],
      spendingCustomerData: [],
      selectedoutlet: [],
      selectedoutletData: [],
      popularItemstData: [],
      selectedTrans: [],
      selectedTransIds: [],
      chartColors: [],
      customersPopularItemstData: [],
      customerDetail: [],
      selectedCustomerIds: [],
      analyticsGroupName: "",
      analyticsGroupNameError: "",
      brandrecommendationdata: [],
      merchantrecommendationdata: [],
      isInitailDataStoreInfo: "Yes",
      storeInfoData: {},
      isInitailDataBrands: "Yes",
      brandsData: [],
      isInitailDataPopularItems: "Yes",
      popularItemsData: [],
      loading: true,
      errorFile: false,
      brandErrorTxt: "",
      merchantErrorTxt: "",
      openApiKeyTxt: "",
      openApiKeyTxtError: "No",
      showOpenApiKey: "No",
    };

    this.inputRef = React.createRef();
  }

  componentDidMount() {
    this.getOverAllData();
    this.getSpendingOutlet();
    this.getSpendingCustomer();
    this.getPopularItems();
    this.getCustomersPurchItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {}

  setShowOpenApiKey() {
    let showOpenApiKey = this.state.showOpenApiKey;
    showOpenApiKey = showOpenApiKey == "Yes" ? "No" : "Yes";
    this.setState({ showOpenApiKey: showOpenApiKey });
  }

  getOverAllData() {
    showLoader("analysis_maintopdiv", "class");
    let fromDateTxt = this.state.fromDate;
    let toDateTxt = this.state.toDate;
    let selectedoutlet = this.state.selectedoutlet;
    selectedoutlet = Object.keys(selectedoutlet).length > 0 ? JSON.stringify(selectedoutlet) : "";
    let selectedTransIds = this.state.selectedTransIds;
    selectedTransIds = Object.keys(selectedTransIds).length > 0 ? JSON.stringify(selectedTransIds) : "";
    var postObject = {
      actionfrom: "client",
      fromDate: fromDateTxt,
      toDate: toDateTxt,
      outletids: selectedoutlet,
      transactionids: selectedTransIds,
    };

    axios.post(apiUrl + "customeranalytics/getTotalInfo", postObject, clientheaderconfig).then((res) => {
      hideLoader("analysis_maintopdiv", "class");
      let overalldata = {};
      if (res.data.status === "ok") {
        overalldata = res.data.result;
      }
      this.setState({ overalldata: overalldata }, function () {
        if (this.state.isInitailDataStoreInfo == "Yes") {
          let overalldata = this.state.overalldata;
          let storeInfoData = {
            totalCustomers: overalldata.totalCustomer,
            totalRevenue: overalldata.totalTransAmt,
            averageSpendPerCustomer: overalldata.avargTransAmt,
          };
          this.setState({ storeInfoData: storeInfoData, isInitailDataStoreInfo: "No" });
        }
      });
    });
  }

  getSpendingOutlet() {
    let fromDateTxt = this.state.fromDate;
    let toDateTxt = this.state.toDate;
    let filtrPrm = "";
    if (fromDateTxt != "" && toDateTxt != "") {
      filtrPrm = "&fromDate=" + fromDateTxt + "&toDate=" + toDateTxt;
    }
    var urlShringTxt = apiUrl + "customeranalytics/getSpendingOutlet?actionfrom=client" + filtrPrm;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        let spendingOutletData = [];
        if (res.data.status === "ok") {
          spendingOutletData = res.data.result;
        }
        this.setState({ spendingOutletData: spendingOutletData }, function () {
          let merchantsData = this.state.spendingOutletData;
          if (Object.keys(merchantsData).length > 0) {
            let brandsDataArr = [];
            const brandsData = Array.from(merchantsData).map((merchant) => {
              const itemsMap = merchant.itemList || new Map();
              if (parseFloat(merchant.value) > 0) {
                let brandObjt = {
                  brand: merchant.name,
                  popularItems: itemsMap.sort((a, b) => b.count - a.count).slice(0, 5),
                };
                brandsDataArr.push(brandObjt);
                return brandObjt;
              }
            });

            this.setState({ brandsData: brandsDataArr, isInitailDataBrands: "No" });
          }
        });
      }
    });
  }

  getSpendingCustomer() {
    let fromDateTxt = this.state.fromDate;
    let toDateTxt = this.state.toDate;
    let filtrPrm = "";
    if (fromDateTxt != "" && toDateTxt != "") {
      filtrPrm = "&fromDate=" + fromDateTxt + "&toDate=" + toDateTxt;
    }
    let selectedoutlet = this.state.selectedoutlet;
    if (Object.keys(selectedoutlet).length > 0) {
      let selectedoutletStr = selectedoutlet.join("_");
      filtrPrm = "&outletid=" + selectedoutletStr;
    }

    var urlShringTxt = apiUrl + "customeranalytics/getSpendingCustomer?actionfrom=client" + filtrPrm;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        let spendingCustomerData = [];
        if (res.data.status === "ok") {
          spendingCustomerData = res.data.result;
        }
        this.setState({ spendingCustomerData: spendingCustomerData });
      }
    });
  }

  getPopularItems() {
    let fromDateTxt = this.state.fromDate;
    let toDateTxt = this.state.toDate;
    let filtrPrm = "";
    if (fromDateTxt != "" && toDateTxt != "") {
      filtrPrm = "&fromDate=" + fromDateTxt + "&toDate=" + toDateTxt;
    }
    var urlShringTxt = apiUrl + "customeranalytics/getPopularItems?actionfrom=client" + filtrPrm;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        let popularItemstData = [];
        let chartColors = [];
        if (res.data.status === "ok") {
          popularItemstData = res.data.result;
          chartColors = res.data.chartColors;
        }
        this.setState({ popularItemstData: popularItemstData, chartColors: chartColors }, function () {
          let popularItemsDataArr = this.state.popularItemstData;
          if (Object.keys(popularItemsDataArr).length > 0) {
            let popularItemsDataNew = [];
            const popularItemsData = Array.from(popularItemsDataArr).map((popularItems) => {
              popularItemsDataNew.push({
                itemName: popularItems.name,
                count: popularItems.value,
              });
              return popularItems;
            });
            popularItemsDataNew = popularItemsDataNew.sort((a, b) => b.count - a.count);
            this.setState({ popularItemsData: popularItemsDataNew, isInitailDataPopularItems: "No" });
          }
        });
      }
    });
  }

  getCustomersPurchItems() {
    let fromDateTxt = this.state.fromDate;
    let toDateTxt = this.state.toDate;
    let selectedoutlet = this.state.selectedoutlet;
    selectedoutlet = Object.keys(selectedoutlet).length > 0 ? JSON.stringify(selectedoutlet) : "";
    let selectedTransIds = this.state.selectedTransIds;
    selectedTransIds = Object.keys(selectedTransIds).length > 0 ? JSON.stringify(selectedTransIds) : "";
    var postObject = {
      actionfrom: "client",
      fromDate: fromDateTxt,
      toDate: toDateTxt,
      outletids: selectedoutlet,
      transactionids: selectedTransIds,
    };

    axios.post(apiUrl + "customeranalytics/getCustomersPurchItems", postObject, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        let customersPopularItemstData = [];
        if (res.data.status === "ok") {
          customersPopularItemstData = res.data.result;
        }
        this.setState({ customersPopularItemstData: customersPopularItemstData });
      }
    });
  }

  getCustomersPurchItemsOld() {
    let fromDateTxt = this.state.fromDate;
    let toDateTxt = this.state.toDate;
    let filtrPrm = "";
    if (fromDateTxt != "" && toDateTxt != "") {
      filtrPrm = "&fromDate=" + fromDateTxt + "&toDate=" + toDateTxt;
    }
    var urlShringTxt = apiUrl + "customeranalytics/getCustomersPurchItems?actionfrom=client" + filtrPrm;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        let customersPopularItemstData = [];
        if (res.data.status === "ok") {
          customersPopularItemstData = res.data.result;
        }
        this.setState({ customersPopularItemstData: customersPopularItemstData });
      }
    });
  }

  sateValChange = (field, value) => {
    if (field === "selecteddate") {
      let sltdFrmDate = "";
      let sltdToDate = "";
      if (value != "" && Object.keys(value).length > 0) {
        let sltdFrmDateObj = new Date(value.from);
        let sltdToDateObj = new Date(value.to);
        sltdFrmDate = this.getDateFrmt(sltdFrmDateObj);
        sltdToDate = this.getDateFrmt(sltdToDateObj);
      }
      this.setState({ fromDate: sltdFrmDate, toDate: sltdToDate, filterIsActive: "Yes", clearDates: "No" }, function () {
        this.getOverAllData();
        this.getSpendingOutlet();
        this.getSpendingCustomer();
        this.getPopularItems();
        this.getCustomersPurchItems();
      });
    }

    if (field === "clearDates") {
      this.setState({ clearDates: value });
    }

    if (field === "clearOulet") {
      this.setState({ clearOulet: value });
    }

    if (field === "clearTrans") {
      this.setState({ clearTrans: value });
    }

    if (field === "selectedoutletold") {
      let filterIsAct = Object.keys(value).length > 0 ? "Yes" : "No";
      this.setState({ selectedoutlet: value, filterIsActive: filterIsAct, clearOulet: "No", clearTrans: "No" }, function () {
        this.getOverAllData();
        this.getSpendingCustomer();
        this.getCustomersPurchItems();
      });
    }

    if (field === "selectedoutlet") {
      let selectedOutletIds = [];
      let filterIsAct = "No";
      if (Object.keys(value).length > 0) {
        let outletdata = value;
        selectedOutletIds = outletdata.map((selectedOutlet) => selectedOutlet.outletid);
        filterIsAct = "Yes";
      }
      this.setState({ selectedoutlet: selectedOutletIds, selectedoutletData: value, filterIsActive: filterIsAct, clearOulet: "No", clearTrans: "No" }, function () {
        this.getOverAllData();
        this.getSpendingCustomer();
        this.getCustomersPurchItems();
      });
    }

    if (field === "selectedTrans") {
      let selectedtramsIds = [];
      let filterIsAct = "No";
      if (Object.keys(value).length > 0) {
        let tramsdata = value;
        selectedtramsIds = [...new Set(tramsdata.flatMap((item) => (item.itemType !== "items" ? item.transIDs : [])))];
        filterIsAct = "Yes";
      }

      this.setState({ selectedTrans: value, selectedTransIds: selectedtramsIds, filterIsActive: filterIsAct, clearOulet: "No", clearTrans: "No" }, function () {
        this.getOverAllData();
        this.getCustomersPurchItems();
      });
    }

    if (field === "selectedcustomer") {
      this.setState({ selectedCustomerIds: value });
    }
  };

  getDateFrmt = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // month is 0-based
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  getNavTabCls(fromCls) {
    let clsNameTxt = "analytics-navbar-col";
    let activeTab = this.state.activeTab;
    if (activeTab == fromCls) {
      clsNameTxt = clsNameTxt + " active";
    }
    return clsNameTxt;
  }

  clearFilterFun() {
    this.setState(
      { fromDate: "", toDate: "", selectedoutlet: [], selectedoutletData: [], selectedTrans: [], selectedTransIds: [], filterIsActive: "No", clearDates: "Yes", clearOulet: "Yes", clearTrans: "Yes" },
      function () {
        this.getOverAllData();
        this.getSpendingOutlet();
        this.getSpendingCustomer();
        this.getPopularItems();
        this.getCustomersPurchItems();
      }
    );
  }

  setNavTabClsFun(actTab) {
    this.setState({ activeTab: actTab });
  }

  setMainTabClsFun(actTab) {
    this.setState({ mainTab: actTab });
  }

  setMerchantType(actTab) {
    this.setState({ merchantType: actTab, merchantrecommendationdata: [] });
  }

  openGroupPopup = () => {
    let selectedCustomerIds = this.state.selectedCustomerIds;
    if (Object.keys(selectedCustomerIds).length > 0) {
      $("#creatgroupmodal").modal("toggle");
    }
  };

  openTragerPopup = (customerID) => {
    if (customerID != "") {
      var urlShringTxt = apiUrl + "customeranalytics/getCustomersPurchInfo?actionfrom=client&customerid=" + customerID;
      axios.get(urlShringTxt, clientheaderconfig).then((res) => {
        if (res.data.status === "ok") {
          let customerDetail = [];
          if (res.data.status === "ok") {
            customerDetail = res.data.result;
          }
          this.setState({ customerDetail: customerDetail }, function () {
            if (Object.keys(customerDetail).length > 0) {
              $("#customermodal").modal("toggle");
            }
          });
        }
      });
    }
  };

  showFltredOutlet() {
    let sltdOutlets = this.state.selectedoutletData;
    let outletNames = sltdOutlets.map((sltdOutlet) => sltdOutlet.name).join(", ");
    return outletNames;
  }

  showFltredItems() {
    let sltdTrans = this.state.selectedTrans;
    let itemNames = sltdTrans.map((sltdTran) => sltdTran.name).join(", ");
    return itemNames;
  }

  handleChangeName = (event) => {
    this.setState({ analyticsGroupName: event.target.value, analyticsGroupNameError: "" });
  };

  handleChangeApiKey = (event) => {
    this.setState({ openApiKeyTxt: event.target.value, openApiKeyTxtError: "No", merchantErrorTxt: "" });
  };

  saveApiKey() {
    let openApiKeyTxtError = "No";
    let showOpenApiKey = "No";
    if (this.state.openApiKeyTxt == "") {
      openApiKeyTxtError = "Yes";
      showOpenApiKey = "Yes";
    }
    this.setState({ showOpenApiKey: showOpenApiKey, openApiKeyTxtError: openApiKeyTxtError, merchantErrorTxt: "" });
  }

  closeApiKeyPopup() {
    this.setState({ showOpenApiKey: "No", openApiKeyTxtError: "", merchantErrorTxt: "" });
  }

  createAnalysisGroup = () => {
    let analyticsGroupName = this.state.analyticsGroupName;
    if (analyticsGroupName != "") {
      showLoader("group_submit_btn", "class");
      let selectedCustomerIds = this.state.selectedCustomerIds;
      let selectedCustomerCount = Object.keys(selectedCustomerIds).length;
      let filterIsApplied = this.state.filterIsActive;
      let filterByDates = "";
      let filterByOutlets = "";
      let filterByItems = "";
      if (filterIsApplied == "Yes") {
        if (this.state.fromDate != "" && this.state.toDate != "") {
          filterByDates = this.state.fromDate + " to " + this.state.toDate;
        }
        if (Object.keys(this.state.selectedoutletData).length > 0) {
          filterByOutlets = JSON.stringify(this.state.selectedoutletData);
        }
        if (Object.keys(this.state.selectedTrans).length > 0) {
          filterByItems = JSON.stringify(this.state.selectedTrans);
        }
      }

      var postObject = {
        analyticsGroupName: analyticsGroupName,
        selectedCustomerCount: selectedCustomerCount,
        selectedCustomerIds: Object.keys(selectedCustomerIds).length > 0 ? JSON.stringify(selectedCustomerIds) : "",
        filterIsApplied: filterIsApplied,
        filterByDates: filterByDates,
        filterByOutlets: filterByOutlets,
        filterByItems: filterByItems,
      };

      axios.post(apiUrl + "customeranalytics/createanalyticsgroup", postObject, clientheaderconfig).then((res) => {
        hideLoader("group_submit_btn", "class");
        if (res.data.status === "success") {
          $("#creatgroupmodal").modal("hide");
          showAlert("Success", "Customer Segment Created Successfully.", "success", "No");
        } else {
          let erroMsg = res.data.message != "" ? res.data.message : "Something is wrong try again.";
          this.setState({ analyticsGroupNameError: erroMsg });
        }
      });
    } else {
      this.setState({ analyticsGroupNameError: "Please enter the customer segment title." });
    }
  };

  genarateBrandRecommendation() {
    let storeInfo = this.state.storeInfoData;
    storeInfo = Object.keys(storeInfo).length > 0 ? JSON.stringify(storeInfo) : "";
    let brands = this.state.brandsData;
    brands = Object.keys(brands).length > 0 ? JSON.stringify(brands) : "";
    let popularItems = this.state.popularItemsData;
    popularItems = Object.keys(popularItems).length > 0 ? JSON.stringify(popularItems) : "";

    if (storeInfo != "" && brands != "" && popularItems != "") {
      showLoader("brand-recommendations-btn", "class");

      var postObject = {
        storeInfo: storeInfo,
        brands: brands,
        popularItems: popularItems,
      };

      axios.post(apiUrl + "customeranalytics/brandRecommendations", postObject, clientheaderconfig).then((res) => {
        hideLoader("brand-recommendations-btn", "class");
        let brandrecommendationdata = {};
        let errorMsg = "";
        if (res.data.status === "ok") {
          brandrecommendationdata = res.data.result;
        } else {
          errorMsg = res.data.message != "" ? res.data.message : "Something is wrong try again.";
        }
        this.setState({ brandrecommendationdata: brandrecommendationdata, brandErrorTxt: errorMsg });
      });
    } else {
      this.setState({ brandErrorTxt: "Need more data to get brand recommendations from OpenAI." });
    }
  }

  genarateMerchantRecommendation() {
    let storeInfo = this.state.storeInfoData;
    if (Object.keys(storeInfo).length > 0) {
      storeInfo.merchantName = cookie.load("clientFirstName");
      storeInfo = JSON.stringify(storeInfo);
    } else {
      storeInfo = "";
    }
    let popularItems = this.state.popularItemsData;
    popularItems = Object.keys(popularItems).length > 0 ? JSON.stringify(popularItems) : "";
    /*let storeInfo = {
            "merchantName": "Best Buy",
            "totalCustomers": 76,
            "totalRevenue": 13622.030000000012,
            "averageSpendPerCustomer": 179.2372368421054
        };
    
    let popularItems = [
      {
          "itemName": "USB Drive",
          "count": 88
      },
      {
          "itemName": "Wireless Mouse",
          "count": 86
      },
      {
          "itemName": "Headphones",
          "count": 85
      },
      {
          "itemName": "HDMI Cable",
          "count": 83
      },
      {
          "itemName": "Keyboard",
          "count": 78
      }
  ];*/
    if (this.state.openApiKeyTxt != "") {
      if (storeInfo != "" && popularItems != "") {
        let merchantRdCls = this.state.merchantType == "holidaypromo" ? "merchant-recommendations-redbtn" : "merchant-recommendations-btn";
        showLoader(merchantRdCls, "class");

        var postObject = {
          storeInfo: storeInfo,
          merchantType: this.state.merchantType,
          popularItems: popularItems,
          openApiKeyTxt: this.state.openApiKeyTxt,
        };

        /*var postObject = {
              storeInfo: JSON.stringify(storeInfo),
              merchantType: this.state.merchantType,
              popularItems: JSON.stringify(popularItems)
            };*/

        axios.post(apiUrl + "customeranalytics/merchantRecommendations", postObject, clientheaderconfig).then((res) => {
          hideLoader(merchantRdCls, "class");
          let merchantrecommendationdata = {};
          let errorMsg = "";
          if (res.data.status === "ok") {
            merchantrecommendationdata = res.data.result;
          } else {
            errorMsg = res.data.message != "" ? res.data.message : "Something is wrong try again.";
          }
          this.setState({ merchantrecommendationdata: merchantrecommendationdata, merchantErrorTxt: errorMsg });
        });
      } else {
        this.setState({ merchantErrorTxt: "Need more data to get merchant recommendations from OpenAI." });
      }
    } else {
      this.setState({ merchantErrorTxt: "Please enter the OpenAI key.", showOpenApiKey: "Yes" }, function () {
        this.inputRef.current.focus();
      });
    }
  }

  render() {
    let overalldata = this.state.overalldata;
    let totalCustomer = 0;
    let totalTransAmt = 0.0;
    let avargTransAmt = 0.0;
    let totalBonusAmt = 0.0;
    if (Object.keys(overalldata).length > 0) {
      totalCustomer = overalldata.totalCustomer;
      totalTransAmt = overalldata.totalTransAmt;
      avargTransAmt = overalldata.avargTransAmt;
      totalBonusAmt = overalldata.totalBonusAmt;
    }
    let customerDetail = this.state.customerDetail;
    let recentTransList = [];
    let topItemsChartData = [];
    let transFirstDate = "";
    if (Object.keys(customerDetail).length > 0) {
      let transFirstDateObj = new Date(customerDetail.transFirstDate);
      transFirstDate = this.getDateFrmt(transFirstDateObj);
      if (Object.keys(customerDetail.recentTransList).length > 0) {
        recentTransList = customerDetail.recentTransList;
      }
      if (Object.keys(customerDetail.topItemsChartData).length > 0) {
        topItemsChartData = customerDetail.topItemsChartData;
      }
    }
    let brandrecommendationdata = this.state.brandrecommendationdata;
    let merchantrecommendationdata = this.state.merchantrecommendationdata;

    console.log("popularItemsData", this.state.popularItemsData);
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"customeranalytics"} />

          {/* layout-page - start */}
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper analysis_maintopdiv">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="col-lg-9 col-md-6">
                  <h4 className="fw-bold">{moduleName}</h4>
                </div>

                <div className="tab-row">
                  <ul>
                    <li className={this.state.mainTab == "analytics" ? "active" : ""} onClick={this.setMainTabClsFun.bind(this, "analytics")}>
                      <Store className="h-4 w-4 shrink-t" /> Analytics
                    </li>
                    {/*<li className={(this.state.mainTab == 'brand')?"active":""} onClick={this.setMainTabClsFun.bind(this,'brand')} >Brand Recommendations</li>*/}
                    <li className={this.state.mainTab == "merchant" ? "active" : ""} onClick={this.setMainTabClsFun.bind(this, "merchant")}>
                      <Users className="h-4 w-4 shrink-t" /> Recommendations
                    </li>
                  </ul>
                </div>

                {/* analytics-maindiv - start */}
                {this.state.mainTab == "analytics" && (
                  <div className="analytics-maindiv">
                    <div className="filter-action-maindiv">
                      <div className="filter-action-row">
                        <div className="filter-action-col1">
                          <Datepickerfun sateValChange={this.sateValChange} clearDates={this.state.clearDates} />
                        </div>
                        <div className="filter-action-col2">
                          <button type="button" onClick={this.clearFilterFun.bind(this)} className="btn btn-label-secondary filter-action-btn">
                            <X /> Clear Filters
                          </button>
                        </div>
                      </div>
                    </div>

                    {this.state.filterIsActive == "Yes" && (
                      <div className="filter-info-topdiv">
                        <div className="filter-info-maindiv">
                          <span className="filter-icon mdi mdi-filter-outline"></span>
                          <span className="filter-text">Showing filtered results ({totalCustomer} customers)</span>
                        </div>

                        {((this.state.fromDate != "" && this.state.toDate != "") || Object.keys(this.state.selectedoutletData).length > 0 || Object.keys(this.state.selectedTrans).length > 0) && (
                          <div className="filter-info-inner">
                            {this.state.fromDate != "" && this.state.toDate != "" && (
                              <div className="filter-info-row">
                                <span className="filter-info-col1">Filter By Date : </span>
                                <span className="filter-info-col2">
                                  {this.state.fromDate} to {this.state.toDate}
                                </span>
                              </div>
                            )}
                            {Object.keys(this.state.selectedoutletData).length > 0 && (
                              <div className="filter-info-row">
                                <span className="filter-info-col1">Filter By Merchant : </span>
                                <span className="filter-info-col2">{this.showFltredOutlet()}</span>
                              </div>
                            )}
                            {Object.keys(this.state.selectedTrans).length > 0 && (
                              <div className="filter-info-row">
                                <span className="filter-info-col1">Filter By Items : </span>
                                <span className="filter-info-col2">{this.showFltredItems()}</span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="customer-overallinfo-grid">
                      <div className="customer-overallinfo-row">
                        <div className="customer-info-grid">
                          <div className="customer-info-header">
                            <div className="customer-infoheader-text">Total Customers</div>
                            <div className="customer-infoheader-icon">
                              <span className="mdi mdi-calendar-blank"></span>
                            </div>
                          </div>
                          <div className="customer-info-body">
                            <span>{totalCustomer}</span>
                          </div>
                        </div>

                        <div className="customer-info-grid">
                          <div className="customer-info-header">
                            <div className="customer-infoheader-text">Total Revenue</div>
                            <div className="customer-infoheader-icon">
                              <DollarSign />
                            </div>
                          </div>
                          <div className="customer-info-body">
                            <span>${totalTransAmt}</span>
                          </div>
                        </div>

                        <div className="customer-info-grid">
                          <div className="customer-info-header">
                            <div className="customer-infoheader-text">Avg. Spend per Customer</div>
                            <div className="customer-infoheader-icon">
                              <span className="mdi mdi-shopping-outline"></span>
                            </div>
                          </div>
                          <div className="customer-info-body">
                            <span>${avargTransAmt}</span>
                          </div>
                        </div>

                        <div className="customer-info-grid">
                          <div className="customer-info-header">
                            <div className="customer-infoheader-text">Total Cashback</div>
                            <div className="customer-infoheader-icon">
                              <DollarSign />
                            </div>
                          </div>
                          <div className="customer-info-body">
                            <span>${totalBonusAmt}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="analytics-navbar-main">
                      <div className="analytics-navbar-row">
                        <div onClick={this.setNavTabClsFun.bind(this, "spending")} className={this.getNavTabCls("spending")}>
                          Spending Analysis
                        </div>
                        <div onClick={this.setNavTabClsFun.bind(this, "popular")} className={this.getNavTabCls("popular")}>
                          Popular Items
                        </div>
                        <div onClick={this.setNavTabClsFun.bind(this, "customer")} className={this.getNavTabCls("customer")}>
                          Customer Analysis
                        </div>
                      </div>
                    </div>

                    {/* analytics-info-container - start */}
                    <div className="analytics-info-container">
                      {this.state.activeTab == "spending" && (
                        <div className="spending_analysis_maindiv">
                          <SpendingAnalysis
                            openTragerPopup={this.openTragerPopup}
                            clearOulet={this.state.clearOulet}
                            sateValChange={this.sateValChange}
                            spendingOutletData={this.state.spendingOutletData}
                            spendingCustomerData={this.state.spendingCustomerData}
                            selectedoutletData={this.state.selectedoutletData}
                          />
                        </div>
                      )}

                      {this.state.activeTab == "popular" && (
                        <div className="popularitems_analysis_maindiv">
                          <PopularItems
                            popularItemstData={this.state.popularItemstData}
                            chartColors={this.state.chartColors}
                            clearTrans={this.state.clearTrans}
                            sateValChange={this.sateValChange}
                            selectedTrans={this.state.selectedTrans}
                          />
                        </div>
                      )}

                      {this.state.activeTab == "customer" && (
                        <div className="customer_analysis_maindiv">
                          <CustomerAnalysis
                            openTragerPopup={this.openTragerPopup}
                            openGroupPopup={this.openGroupPopup}
                            sateValChange={this.sateValChange}
                            customersPopularItemstData={this.state.customersPopularItemstData}
                          />
                        </div>
                      )}
                    </div>
                    {/* analytics-info-container - end */}
                  </div>
                )}
                {/* analytics-maindiv - end */}

                {/* brand-recommendations-maindiv - start */}
                {this.state.mainTab == "brand" && (
                  <div className="brand-recommendations-maindiv">
                    <div className="brand-recommendations-title">
                      <h5 className="brand-recommendations-titletxt">
                        <Gift /> <span>Brand Recommendations</span>
                      </h5>
                      <p className="brand-recommendations-titleinfo">Generate brand-specific promotions using AI</p>
                    </div>

                    <div className="brand-recommendations-action">
                      <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light brand-recommendations-btn" onClick={this.genarateBrandRecommendation.bind(this)}>
                        Generate Brand Recommendations
                      </button>
                    </div>

                    {this.state.brandErrorTxt != "" && (
                      <div className="brand-recommendations-errorinfo">
                        <p>
                          <TriangleAlert /> {this.state.brandErrorTxt}
                        </p>
                      </div>
                    )}

                    {brandrecommendationdata.length > 0 && (
                      <div className="brand-recommendations-prodmaindiv">
                        {brandrecommendationdata.map((brandrecommend, brdindex) => {
                          let productList = brandrecommend.products;
                          return (
                            <div className="brand-recommendations-prolist" key={brdindex}>
                              <div className="brand-recommendations-proheader">
                                <h5>{brandrecommend.title}</h5>
                              </div>
                              {Object.keys(productList).length > 0 && (
                                <div className="brand-recommendations-probody">
                                  <div className="brand-recommendations-protitle">
                                    <ShoppingCart /> <span>Recommended Products:</span>
                                  </div>
                                  <div className="row brand-recommendations-prorow">
                                    {productList.map((products, proIndx) => {
                                      return (
                                        <div className="brand-recommendations-procol">
                                          <Package /> {products.length > 64 ? <span>{products.substring(0, 64)}...</span> : <span>{products}</span>}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                {/* brand-recommendations-maindiv - end */}

                {/* merchant-recommendations-maindiv - start */}
                {this.state.mainTab == "merchant" && (
                  <div className="brand-recommendations-maindiv merchant-recommendations-maindiv">
                    <div className="brand-recommendations-title-keyconfig">
                      <div className="brand-recommendations-title">
                        <h5 className="brand-recommendations-titletxt">
                          <Gift /> <span>Merchant Recommendations</span>
                        </h5>
                        <p className="brand-recommendations-titleinfo">Generate merchant-specific promotions using AI</p>
                      </div>

                      <div className="brand-recommendations-keyconfig">
                        <div className="brand-recommendations-keyconfigbtndiv">
                          <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light brand-recommendations-keyconfigbtn" onClick={this.setShowOpenApiKey.bind(this)}>
                            <Settings className="h-4 w-4 shrink-st" /> Configure API Key
                          </button>
                        </div>
                        {this.state.showOpenApiKey == "Yes" && (
                          <div className="brand-recommendations-keyconfiginfodiv">
                            <div className="brand-recommendations-keyconfig-info">
                              <div className="brand-recommendations-keyconfig-infotitle">
                                <h5>
                                  OpenAI API Settings <X className="h-4 w-4 shrink-x" onClick={this.closeApiKeyPopup.bind(this)} />
                                </h5>
                                <p>Your API key is stored locally and never sent to our servers.</p>
                              </div>

                              <div className="brand-recommendations-keyconfig-input">
                                <input
                                  type="text"
                                  className={this.state.openApiKeyTxtError == "Yes" ? "form-control input-error-cls" : "form-control"}
                                  name="open_api_key"
                                  value={this.state.openApiKeyTxt}
                                  onChange={this.handleChangeApiKey}
                                  ref={this.inputRef}
                                />
                              </div>

                              <div className="brand-recommendations-keyconfig-action">
                                <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light brand-recommendations-keyconfig-actbtn" onClick={this.saveApiKey.bind(this)}>
                                  <Save className="h-4 w-4 shrink-atc" /> Save API Key
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="merchant-recommendations-filterinfo">
                      <Users className="h-4 w-4 shrink-0" />{" "}
                      <span className="merchant-rm-filtertxt">
                        Based on data from {totalCustomer} customers at {cookie.load("clientFirstName")}
                      </span>
                    </div>

                    <div className="merchant-recommendations-types">
                      <div
                        className={this.state.merchantType == "bundleoffer" ? "merchant-recommendations-type1 active" : "merchant-recommendations-type1"}
                        onClick={this.setMerchantType.bind(this, "bundleoffer")}
                      >
                        <Gift className="h-4 w-4 shrink-g" /> <span className="merchant-rm-type1txt">Bundle Offers</span>
                      </div>
                      <div
                        className={this.state.merchantType == "holidaypromo" ? "merchant-recommendations-type2 active" : "merchant-recommendations-type2"}
                        onClick={this.setMerchantType.bind(this, "holidaypromo")}
                      >
                        <PartyPopper className="h-4 w-4 shrink-g" /> <span className="merchant-rm-type2txt">Holiday Promos</span>
                      </div>
                    </div>

                    {this.state.merchantType == "bundleoffer" && (
                      <div className="merchant-recommendations-action">
                        <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light merchant-recommendations-btn" onClick={this.genarateMerchantRecommendation.bind(this)}>
                          Generate Bundle Recommendations
                        </button>
                      </div>
                    )}

                    {this.state.merchantType == "holidaypromo" && (
                      <div className="merchant-recommendations-action">
                        <button type="button" class="btn btn-primary me-sm-3 me-1 waves-effect waves-light merchant-recommendations-redbtn" onClick={this.genarateMerchantRecommendation.bind(this)}>
                          Generate Holiday Recommendations
                        </button>
                      </div>
                    )}

                    {this.state.merchantErrorTxt != "" && (
                      <div className="brand-recommendations-errorinfo">
                        <p>
                          <TriangleAlert /> {this.state.merchantErrorTxt}
                        </p>
                      </div>
                    )}

                    {merchantrecommendationdata.length > 0 && (
                      <div className="brand-recommendations-prodmaindiv">
                        {merchantrecommendationdata.map((merchantrecommend, brdindex) => {
                          let productListTxt = merchantrecommend.products;
                          //let productLists = (productListTxt != "") ? productListTxt.split(',') : [];
                          return (
                            <div className="brand-recommendations-prolist" key={brdindex}>
                              <div className="brand-recommendations-proheader">
                                <h5>{merchantrecommend.title}</h5>
                              </div>

                              {productListTxt != "" && (
                                <div className="merchant-recommendations-probody">
                                  <div className="merchant-recommendations-protitle">
                                    <ShoppingCart /> <span>Products</span>
                                  </div>
                                  <div className="merchant-recommendations-prorow">
                                    <span>{productListTxt}</span>
                                  </div>
                                </div>
                              )}

                              {merchantrecommend.discount != "" && (
                                <div className="merchant-recommendations-probody">
                                  <div className="merchant-recommendations-protitle">
                                    <LucideTag className="lucidetag-icon" /> <span>Discount Structure</span>
                                  </div>
                                  <div className="merchant-recommendations-prorow">
                                    <span>{merchantrecommend.discount}</span>
                                  </div>
                                </div>
                              )}

                              {merchantrecommend.reason != "" && (
                                <div className="merchant-recommendations-probody">
                                  <div className="merchant-recommendations-protitle">
                                    <Lightbulb className="lightbulb-icon" /> <span>Appeal Explanation</span>
                                  </div>
                                  <div className="merchant-recommendations-prorow">
                                    <span>{merchantrecommend.reason}</span>
                                  </div>
                                </div>
                              )}

                              {merchantrecommend.impact != "" && (
                                <div className="merchant-recommendations-probody">
                                  <div className="merchant-recommendations-protitle">
                                    <TrendingUp className="trendingup-icon" /> <span>Revenue Impact</span>
                                  </div>
                                  <div className="merchant-recommendations-prorow">
                                    <span>{merchantrecommend.impact}</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                {/* merchant-recommendations-maindiv - end */}
              </div>
              <Footer />
            </div>
          </div>
          {/* layout-page - end */}
        </div>

        {/* customer popup - start */}
        <div className="modal fade customer_anlys_modal" id="customermodal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Customer Details</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <p className="modal-sub-title">Detailed analytics for John Moore</p>
              {/* modal-body - start */}
              {Object.keys(customerDetail).length > 0 && (
                <div className="modal-body">
                  <div className="modal-innerdiv">
                    <div className="row customer-basic-info">
                      <div className="col-md-4">
                        <label>Customer ID</label>
                        <div className="txt-info">{customerDetail.customerId}</div>
                      </div>
                      <div className="col-md-4">
                        <label>Mobile Number</label>
                        <div className="txt-info">+65{customerDetail.customerPhone}</div>
                      </div>
                      <div className="col-md-4">
                        <label>Name</label>
                        <div className="txt-info">{customerDetail.customerName}</div>
                      </div>
                    </div>

                    <div className="row customer-wallet-info">
                      <div className="col-md-4">
                        <label>Total Spent</label>
                        <div className="txt-info">${customerDetail.transAmount}</div>
                      </div>
                      <div className="col-md-4">
                        <label>Receipts Count</label>
                        <div className="txt-info">{customerDetail.totalTransCount}</div>
                      </div>
                      <div className="col-md-4">
                        <label>First Purchase</label>
                        <div className="txt-info">{transFirstDate}</div>
                      </div>
                    </div>

                    <div className="customer-cashback-info">
                      <div className="customer-cashback-earned">
                        <div className="customer-cashbackearned-title">Total Cashback Earned</div>
                        <div className="customer-cashbackearned-amount">${customerDetail.transBonusAmount}</div>
                        <div className="customer-cashbackearned-info">3.0% of total spend</div>
                      </div>
                      <div className="customer-recent-cashback">
                        <div className="customer-recentcashback-title">Recent Cashback</div>
                        <div className="customer-recentcashback-amount">${customerDetail.recentBonusAmont}</div>
                        <div className="customer-recentcashback-info">From last 3 transactions</div>
                      </div>
                    </div>

                    <div className="customer-purchaseditems-receipts">
                      <div className="customer-purchaseditems">
                        <div className="customer-purchaseditems-header">Most Frequently Purchased Items</div>
                        {Object.keys(topItemsChartData).length > 0 && (
                          <div className="customer-purchaseditems-chart">
                            <ResponsiveContainer width="100%" height={300}>
                              <BarChart data={topItemsChartData} margin={{ left: -30 }} layout="vertical">
                                <CartesianGrid strokeDasharray="1 3" />
                                <XAxis type="number" tick={{ fontSize: 12 }} />
                                <YAxis type="category" dataKey="name" width={120} tickLine={false} axisLine={false} tick={{ fontSize: 12 }} />
                                <Tooltip
                                  formatter={(value) => [`${value} items`, "Quantity"]}
                                  labelFormatter={(label) => {
                                    const item = topItemsChartData.find((item) => item.name === label);
                                    return item?.fullName || label;
                                  }}
                                  contentStyle={{
                                    fontSize: "10px",
                                    background: "white",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "0.5rem",
                                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                                  }}
                                />
                                <Bar dataKey="value" fill="#4f46e5" barSize={30} radius={[0, 4, 4, 0]} />
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        )}
                      </div>
                      <div className="customer-receipts-maindiv">
                        <div className="customer-receipts-header">Recent Receipts</div>
                        <div className="customer-receipts-table">
                          {Object.keys(recentTransList).length > 0 && (
                            <div className="topspenders_table_maindiv">
                              <table className="topspenders_table" style={{ width: "100%" }}>
                                <tr>
                                  <th style={{ width: "22%" }}>Date</th>
                                  <th style={{ width: "38%" }}>Merchant</th>
                                  <th style={{ width: "20%" }}>Items</th>
                                  <th style={{ width: "20%" }}>Total</th>
                                </tr>
                                {recentTransList.map((item, index) => {
                                  let purchDateObj = new Date(item.purchDate);
                                  return (
                                    <tr key={index}>
                                      <td>{this.getDateFrmt(purchDateObj)}</td>
                                      <td>{item.outletName}</td>
                                      <td>{item.transItemcount} Item(s)</td>
                                      <td>{parseFloat(item.transAmount).toFixed(2)}</td>
                                    </tr>
                                  );
                                })}
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* modal-body - end */}
            </div>
          </div>
        </div>
        {/* customer poup - end */}

        {/* creat group popup - start */}
        <div className="modal fade customer_anlysgroup_modal" id="creatgroupmodal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Customer Segment</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <p className="modal-sub-title">To create customer segment based on filter and customer selection</p>
              {/* modal-body - start */}
              {Object.keys(this.state.selectedCustomerIds).length > 0 && (
                <div className="modal-body">
                  <div className="modal-innerdiv">
                    <div className="card-body row g-3">
                      <div className="col-md-8">
                        <div className="form-floating form-floating-outline mb-1">
                          <input type="text" className="form-control" name="analytics_group_name" value={this.state.analyticsGroupName} onChange={this.handleChangeName} />
                          <label htmlFor="analytics_group_name">
                            Customer Segment Title<span className="error">*</span>
                          </label>
                        </div>
                        {this.state.analyticsGroupNameError != "" && <p className="anlysgroup_name_error">{this.state.analyticsGroupNameError}</p>}
                      </div>
                      <div className="col-md-4">
                        <div className="form-floating form-floating-outline mb-1">
                          <input type="text" className="form-control" disabled={true} name="selected_customer_count" value={Object.keys(this.state.selectedCustomerIds).length} />
                          <label htmlFor="selected_customer_count">
                            Selected Customer Count <span className="error">*</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    {this.state.filterIsActive == "Yes" && (
                      <div className="filter-info-topdiv">
                        <div className="filter-info-maindiv">
                          <span className="filter-icon mdi mdi-filter-outline"></span>
                          <span className="filter-text">Showing filtered results ({totalCustomer} customers)</span>
                        </div>

                        {((this.state.fromDate != "" && this.state.toDate != "") || Object.keys(this.state.selectedoutletData).length > 0 || Object.keys(this.state.selectedTrans).length > 0) && (
                          <div className="filter-info-inner">
                            {this.state.fromDate != "" && this.state.toDate != "" && (
                              <div className="filter-info-row">
                                <span className="filter-info-col1">Filter By Date : </span>
                                <span className="filter-info-col2">
                                  {this.state.fromDate} to {this.state.toDate}
                                </span>
                              </div>
                            )}
                            {Object.keys(this.state.selectedoutletData).length > 0 && (
                              <div className="filter-info-row">
                                <span className="filter-info-col1">Filter By Merchant : </span>
                                <span className="filter-info-col2">{this.showFltredOutlet()}</span>
                              </div>
                            )}
                            {Object.keys(this.state.selectedTrans).length > 0 && (
                              <div className="filter-info-row">
                                <span className="filter-info-col1">Filter By Items : </span>
                                <span className="filter-info-col2">{this.showFltredItems()}</span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="pb-2 pt-3 text-center">
                      <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light group_submit_btn submit_frm" onClick={this.createAnalysisGroup.bind(this)}>
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* modal-body - end */}
            </div>
          </div>
        </div>
        {/* creat group poup - end */}
      </div>
    );
  }
}

export default List;
